// Styles
import { GiPadlock } from "react-icons/gi";
import { Wrapper, BoxIcon } from "./styles";

interface BotaoProps {
  ariaLabel: string;
  value: string;
  disabled: boolean | undefined;
  onClick: () => any;
}

export default function BotaoCadeado({
  ariaLabel,
  value,
  onClick,
  disabled,
}: BotaoProps) {
  return (
    <Wrapper
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      className={disabled ? "disabled" : ""}
    >
      {value}
      {disabled ? (
        <BoxIcon>
          <GiPadlock />
        </BoxIcon>
      ) : null}
    </Wrapper>
  );
}
